@if (isLoading) {
  <div class="button-wrapper-dummy margin-above">
    <div class="panel-dummy">
      <div class="shine"></div>
    </div>
    <div class="panel-dummy">
      <div class="shine"></div>
    </div>
    <div class="panel-dummy">
      <div class="shine"></div>
    </div>
  </div>

  <div class="panel-title-dummy margin-above">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>

  <div class="panel-title-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
}
@else {
<!-- Offline XPAC buttons -->
<div class="action-buttons margin-above" *ngIf="!xpac.isConnected">
  <!-- Manage -->
  <ng-container *ngIf="('licenses' | hasPermission : 'RemoteMaintenance_License' : 'read' | async)">
    <button [disabled]="isDeleting" mat-flat-button class="button small-button" (click)="openXpacManagement()">
      <mat-icon>manage_accounts</mat-icon>
      <p>{{ 'Modules.RemoteMaintenance.Connections.Manage' | translate }}</p>
    </button>
    <mat-divider *ngIf="('devices' | hasPermission :'Device':'delete' | async)" [vertical]="true"
      class="mat-divider-width"></mat-divider>
  </ng-container>

  <!-- Delete -->
  <ng-container *ngIf="('devices' | hasPermission :'Device':'delete' | async)">
    <button [disabled]="isDeleting" mat-flat-button class="button small-button" (click)="deleteXpac()">
      <mat-icon>delete</mat-icon>
      <p>{{ 'Modules.RemoteMaintenance.Connections.Delete' | translate }}</p>
    </button>
  </ng-container>
</div>

<!-- Online XPAC buttons -->
<div class="action-buttons margin-above" *ngIf="xpac.isConnected">
  <!-- Restart -->
  <ng-container *ngIf="('devices' | hasPermission :'Device_Restart':'action' | async)">
    <button [disabled]="isDeleting" mat-flat-button class="button small-button" (click)="restartXpac()">
      <mat-icon>autorenew</mat-icon>
      <p>{{ 'Modules.RemoteMaintenance.Connections.Restart' | translate }}</p>
    </button>
    <mat-divider [vertical]="true" class="mat-divider-width"></mat-divider>
  </ng-container>

  <!-- Manage -->
  <ng-container *ngIf="('licenses' | hasPermission : 'RemoteMaintenance_License' : 'read' | async)">
    <button [disabled]="isDeleting" mat-flat-button class="button small-button" (click)="openXpacManagement()">
      <mat-icon>manage_accounts</mat-icon>
      <p>{{ 'Modules.RemoteMaintenance.Connections.Manage' | translate }}</p>
    </button>
    <mat-divider [vertical]="true" class="mat-divider-width"></mat-divider>
  </ng-container>

  <!-- Connect -->
  <button [disabled]="isDeleting" mat-flat-button class="button small-button" (click)="redirectToRemoteXPAC()">
    <mat-icon>login</mat-icon>
    <p>{{ 'Modules.RemoteMaintenance.Connections.Connect' | translate }}</p>
  </button>
</div>

<!-- XPAC Details -->
<div>
  <h2 class="panel-title">{{ 'Modules.RemoteMaintenance.RemoteMaintenanceItemInfoData.XPACDetails' | translate }}</h2>
  <div class="details-card">
    <div>
      <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.RemoteMaintenanceItemInfoData.FirmwareVersion' | translate
        }}
      </h4>
      <div class="detail-value">{{ getFirmwareVersion() }}</div>
    </div>
  </div>
</div>

<!-- License status -->
<div *ngIf="('licenses' | hasPermission :'RemoteMaintenance.SubscriptionEndDate':'read' | async)">

  <h2 class="panel-title">{{ 'Modules.Licenses.List.OrderHistory.OrderDetails.LicenseInfo' | translate }}</h2>
  <div class="details-card">
    <div>
      <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.RemoteMaintenanceItemInfoData.LicenseSerial' | translate
        }}
      </h4>
      <div class="detail-value">{{ getSerial() }}</div>
    </div>

    <div>
      <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.RemoteMaintenanceItemInfoData.State' | translate }}</h4>
      <div class="detail-value">{{ getEndDate() }}</div>
    </div>
  </div>
</div>

<!-- Active problems -->
<div *ngIf="('devices' | hasPermission :'Device_Problems':'read' | async)">
  <h2 class="panel-title">{{ 'Modules.RemoteMaintenance.Problems.AllActiveIssues' | translate }}</h2>

  <div *ngIf="currentProblems?.length; then active_problems else no_active_problems"></div>

  <ng-template #active_problems>
    <div class="panel">
      <app-list-item *ngFor="let problem of currentProblems" title="{{ getProblemTitle(problem) }}"
        info="{{ (problem.startUtc | localizedDate: 'short') + ' - ' + getProblemInfo(problem) }}"></app-list-item>
    </div>
  </ng-template>

  <ng-template #no_active_problems>
    <p class="p-form-group">{{ 'Modules.RemoteMaintenance.Problems.NoActiveIssues' | translate }}</p>
  </ng-template>
</div>
}